import { render, staticRenderFns } from "./theme-box.vue?vue&type=template&id=69449652&"
import script from "./theme-box.vue?vue&type=script&lang=js&"
export * from "./theme-box.vue?vue&type=script&lang=js&"
import style0 from "./theme-box.vue?vue&type=style&index=0&id=69449652&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports